import {
  Alert,
  Box,
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

import { useTranslation } from 'react-i18next';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from '../../../redux/usersRedux';
import { loadReportPZ04ByIdRequest } from '../../../redux/reportsPZ04Redux';
import {
  createRNFiz2Request,
  updateRNFiz2Request,
} from '../../../redux/rnfizRedux';
const RozlewFiz = ({ props }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => getUser(state));
  const { t } = useTranslation();
  const [reason, setReason] = useState(
    props.RN_Fiz_2 ? props.RN_Fiz_2.reason : '',
  );
  const [fillingDate, setFillingDate] = useState(
    props.RN_Fiz_2 ? dayjs(props.RN_Fiz_2.fillingDate) : dayjs(new Date()),
  );
  const [userSignature, setUserSignature] = useState(
    props.RN_Fiz_2
      ? `${props.RN_Fiz_2.user.firstName} ${props.RN_Fiz_2.user.lastName}`
      : '',
  );
  const [userSignatureId, setUserSignatureId] = useState(
    user ? user.users.id : '',
  );
  const [details, setDetails] = useState(
    props.RN_Fiz_2 ? props.RN_Fiz_2.details : '',
  );
  const [actions, setActions] = useState(
    props.RN_Fiz_2 ? props.RN_Fiz_2.actions : '',
  );
  const [saveIn, setSaveIn] = useState(
    props.RN_Fiz_2 ? props.RN_Fiz_2.saveIn : '',
  );
  const [problemDatabaseNumber, setProblemDatabaseNumber] = useState(
    props.RN_Fiz_2 ? props.RN_Fiz_2.problemDatabaseNumber : '',
  );
  const [hlQty, setHlQty] = useState(
    props.RN_Fiz_2 ? props.RN_Fiz_2.hlQty : '',
  );

  const [dateAnalysis, setDateAnalysis] = useState(
    props.RN_Fiz_2 ? props.RN_Fiz_2 : false,
  );
  const [casQty, setCasQty] = useState(
    props.RN_Fiz_2 ? props.RN_Fiz_2.casQty : '',
  );
  const [reloadReport, setReloadReport] = useState(0);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState('success');
  const [alertMessage, setAlertMessage] = useState('');

  useEffect(() => {
    const start = async () => {
      if (user && userSignature === '') {
        setUserSignature(`${user.users.firstName} ${user.users.lastName}`);
        setUserSignatureId(user.users.id);
      }
    };
    start();
  }, [user]);

  useEffect(() => {
    const start = async () => {
      console.log('Ładowanie danych rozlewu mikrobiologii...');
      const res = await dispatch(loadReportPZ04ByIdRequest(props.id));
      if (res) {
        setDateAnalysis(res.data.RN_Fiz_2 ? res.data.RN_Fiz_2 : false);
        console.log(
          'Dane rozlewu mikrobiologii załadowane:',
          res.data.RN_Fiz_2,
        );
      }
    };
    start();
  }, [dispatch, props.id, reloadReport]);

  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        bulletList: { keepMarks: true, keepAttributes: false },
        orderedList: { keepMarks: true, keepAttributes: false },
      }),
      Underline,
    ],
    content: reason,
    onUpdate: ({ editor }) => {
      const html = editor.getHTML(); // Pobiera HTML z edytora
      setReason(html); // Ustawia stan z HTML
    },
  });

  const descriptionEditor = useEditor({
    extensions: [
      StarterKit.configure({
        bulletList: { keepMarks: true, keepAttributes: false },
        orderedList: { keepMarks: true, keepAttributes: false },
      }),
      Underline,
    ],
    content: details,
    onUpdate: ({ editor }) => {
      const html = editor.getHTML(); // Pobiera HTML z edytora
      setDetails(html); // Ustawia stan z HTML
    },
  });

  const handleCasToHlConversion = (casQty) => {
    const hlQty = parseFloat(casQty) * props.orderProduct.casHL; // Przykładowa konwersja: 1 hl = 100 cas
    return isNaN(hlQty) ? '' : hlQty.toFixed(2); // Zwraca sformatowaną wartość lub pusty string
  };

  useEffect(() => {
    const convertedHlQty = handleCasToHlConversion(casQty);
    setHlQty(convertedHlQty);
  }, [casQty]);

  const handleSave = async (e) => {
    e.preventDefault();

    const dane_rozlewu = {
      reportPZ04Id: props.id,
      fillingDate: dayjs(fillingDate),
      userId: userSignatureId,
      reason: reason,
      details: details,
      actions: actions,
      saveIn: saveIn,
      problemDatabaseNumber: problemDatabaseNumber,
      hlQty: hlQty,
      casQty: casQty,
    };
    console.log('Data to save:', dane_rozlewu);

    if (dateAnalysis) {
      const res = await dispatch(
        updateRNFiz2Request({
          id: dateAnalysis.id,
          ...dane_rozlewu,
        }),
      );

      if (res.status === 200) {
        console.log(
          'Dane rozlewu mikrobiologii zostały zaktualizowane pomyślnie.',
          res,
        );
        setAlertSeverity('success');
        setAlertMessage(t('rnModule.fiz_2.snackbar.successUpdateData'));
        setAlertOpen(true);
        setReloadReport((prev) => prev + 1);
      } else {
        console.log(
          'Wystąpił błąd podczas aktualizacji danych rozlewu mikrobiologii.',
          res,
        );
        setAlertSeverity('error');
        setAlertMessage(t('rnModule.fiz_2.snackbar.errorUpdateData'));
        setAlertOpen(true);
      }
    } else {
      const res = await dispatch(createRNFiz2Request(dane_rozlewu));

      if (res.status === 201) {
        console.log(
          'Dane rozlewu mikrobiologii zostały zapisane pomyślnie.',
          res,
        );
        setAlertSeverity('success');
        setAlertMessage(t('rnModule.fiz_2.snackbar.successAddData'));
        setAlertOpen(true);
        setReloadReport((prev) => prev + 1);
      } else {
        console.log(
          'Wystąpił błąd podczas zapisywania danych rozlewu mikrobiologii.',
          res,
        );
        setAlertSeverity('error');
        setAlertMessage(t('rnModule.fiz_2.snackbar.errorAddData'));
        setAlertOpen(true);
      }
    }
  };

  if (!editor) return null;
  if (!descriptionEditor) return null;

  return (
    <Box
      sx={{ overflow: 'auto', maxHeight: 'calc(100vh - 200px)' }}
      component={'form'}
      onSubmit={handleSave}
    >
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={alertOpen}
        autoHideDuration={6000}
        onClose={() => setAlertOpen(false)}
      >
        <Alert
          variant="filled"
          onClose={() => setAlertOpen(false)}
          severity={alertSeverity}
          sx={{ width: '100%' }}
        >
          {alertMessage}
        </Alert>
      </Snackbar>
      <Typography
        variant="h6"
        component="h2"
        gutterBottom
        fontWeight="bold"
        fontStyle="italic"
      >
        {t('rnModule.fiz_2.stage_results')}
      </Typography>
      <Divider sx={{ width: '100%', mb: 2, bgcolor: '#C09A53' }} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          mb: 2,
          justifyContent: 'left',
        }}
      >
        <LocalizationProvider adapterLocale="pl" dateAdapter={AdapterDayjs}>
          <DatePicker
            format="DD.MM.YYYY"
            views={['year', 'month', 'day']}
            label={t('rnModule.fiz_2.date')}
            value={dayjs(fillingDate)}
            onChange={(newValue) => {
              setFillingDate(dayjs(newValue));
            }}
            slotProps={{
              textField: {
                error: false,
              },
            }}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
        <TextField
          sx={{ width: '25%', ml: 2, mr: 2 }}
          label={t('rnModule.fiz_2.signature')}
          variant="outlined"
          value={userSignature}
          disabled
        />
      </Box>

      {/* Przyczyna niezgodności */}

      <Box sx={{ mt: 2 }}>
        <Typography
          variant="h6"
          component="h2"
          gutterBottom
          fontWeight="bold"
          fontStyle="italic"
        >
          {t('rnModule.fiz_2.reason')}
        </Typography>
        <Divider sx={{ width: '100%', mb: 2, bgcolor: '#C09A53' }} />
        {editor && (
          <Stack direction="row" spacing={1} mb={1}>
            <IconButton
              onClick={() => editor.chain().focus().toggleBold().run()}
              sx={{
                color: editor.isActive('bold') ? 'primary.main' : 'inherit',
                bgcolor: editor.isActive('bold')
                  ? 'action.selected'
                  : 'transparent',
              }}
            >
              <FormatBoldIcon />
            </IconButton>
            <IconButton
              onClick={() => editor.chain().focus().toggleItalic().run()}
              sx={{
                color: editor.isActive('italic') ? 'primary.main' : 'inherit',
                bgcolor: editor.isActive('italic')
                  ? 'action.selected'
                  : 'transparent',
              }}
            >
              <FormatItalicIcon />
            </IconButton>
            <IconButton
              onClick={() => editor.chain().focus().toggleUnderline().run()}
              sx={{
                color: editor.isActive('underline')
                  ? 'primary.main'
                  : 'inherit',
                bgcolor: editor.isActive('underline')
                  ? 'action.selected'
                  : 'transparent',
              }}
            >
              <FormatUnderlinedIcon />
            </IconButton>
            <IconButton
              onClick={() => editor.chain().focus().toggleOrderedList().run()}
              sx={{
                color: editor.isActive('orderedList')
                  ? 'primary.main'
                  : 'inherit',
                bgcolor: editor.isActive('orderedList')
                  ? 'action.selected'
                  : 'transparent',
              }}
            >
              <FormatListNumberedIcon />
            </IconButton>
            <IconButton
              onClick={() => editor.chain().focus().toggleBulletList().run()}
              sx={{
                color: editor.isActive('bulletList')
                  ? 'primary.main'
                  : 'inherit',
                bgcolor: editor.isActive('bulletList')
                  ? 'action.selected'
                  : 'transparent',
              }}
            >
              <FormatListBulletedIcon />
            </IconButton>
          </Stack>
        )}
        <Paper
          variant="outlined"
          sx={{
            borderRadius: 2,
            minHeight: 150,
            cursor: 'text', // Dodaj kursor
            '& .ProseMirror': {
              // Stylujemy wewnętrzny element edytora
              minHeight: '400px', // Dzięki temu będzie miejsce do klikania
            },
          }}
        >
          <EditorContent editor={editor} />
        </Paper>
      </Box>

      {/* Koniec przyczyny niezgodności */}

      {/* Opis podjetych dzialan */}

      <Box sx={{ mt: 2 }}>
        <Typography
          variant="h6"
          component="h2"
          gutterBottom
          fontWeight="bold"
          fontStyle="italic"
        >
          {t('rnModule.fiz_2.description')}
        </Typography>
        <Divider sx={{ width: '100%', mb: 2, bgcolor: '#C09A53' }} />

        {descriptionEditor && (
          <Stack direction="row" spacing={1} mb={1}>
            <IconButton
              onClick={() =>
                descriptionEditor.chain().focus().toggleBold().run()
              }
              sx={{
                color: descriptionEditor.isActive('bold')
                  ? 'primary.main'
                  : 'inherit',
                bgcolor: descriptionEditor.isActive('bold')
                  ? 'action.selected'
                  : 'transparent',
              }}
            >
              <FormatBoldIcon />
            </IconButton>
            <IconButton
              onClick={() =>
                descriptionEditor.chain().focus().toggleItalic().run()
              }
              sx={{
                color: descriptionEditor.isActive('italic')
                  ? 'primary.main'
                  : 'inherit',
                bgcolor: descriptionEditor.isActive('italic')
                  ? 'action.selected'
                  : 'transparent',
              }}
            >
              <FormatItalicIcon />
            </IconButton>
            <IconButton
              onClick={() =>
                descriptionEditor.chain().focus().toggleUnderline().run()
              }
              sx={{
                color: descriptionEditor.isActive('underline')
                  ? 'primary.main'
                  : 'inherit',
                bgcolor: descriptionEditor.isActive('underline')
                  ? 'action.selected'
                  : 'transparent',
              }}
            >
              <FormatUnderlinedIcon />
            </IconButton>
            <IconButton
              onClick={() =>
                descriptionEditor.chain().focus().toggleOrderedList().run()
              }
              sx={{
                color: descriptionEditor.isActive('orderedList')
                  ? 'primary.main'
                  : 'inherit',
                bgcolor: descriptionEditor.isActive('orderedList')
                  ? 'action.selected'
                  : 'transparent',
              }}
            >
              <FormatListNumberedIcon />
            </IconButton>
            <IconButton
              onClick={() =>
                descriptionEditor.chain().focus().toggleBulletList().run()
              }
              sx={{
                color: descriptionEditor.isActive('bulletList')
                  ? 'primary.main'
                  : 'inherit',
                bgcolor: descriptionEditor.isActive('bulletList')
                  ? 'action.selected'
                  : 'transparent',
              }}
            >
              <FormatListBulletedIcon />
            </IconButton>
          </Stack>
        )}
        <Paper
          variant="outlined"
          sx={{
            borderRadius: 2,
            minHeight: 150,
            cursor: 'text', // Dodaj kursor
            '& .ProseMirror': {
              // Stylujemy wewnętrzny element edytora
              minHeight: '400px', // Dzięki temu będzie miejsce do klikania
            },
          }}
        >
          <EditorContent editor={descriptionEditor} />
        </Paper>
      </Box>

      {/* Koniec opisu podjetych dzialan */}

      {/* Czy dzialania zostaly podjete */}

      <Box sx={{ mt: 2 }}>
        <Typography
          variant="h6"
          component="h2"
          gutterBottom
          fontWeight="bold"
          fontStyle="italic"
        >
          {t('rnModule.fiz_2.actions_taken')}
        </Typography>
        <Divider sx={{ width: '100%', mb: 2, bgcolor: '#C09A53' }} />
        <FormControl sx={{ width: '100%' }}>
          <RadioGroup
            aria-labelledby="actions-taken-radio-buttons"
            name="actions-taken"
            value={actions}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-evenly',
            }}
          >
            <FormControlLabel
              value={true}
              control={<Radio />}
              label={t('rnModule.fiz_2.actons_yes')}
              onChange={() => {
                setActions(true);
              }}
            />
            <FormControlLabel
              value={false}
              control={<Radio />}
              label={t('rnModule.fiz_2.actions_no')}
              onChange={() => {
                setActions(false);
              }}
            />
          </RadioGroup>
        </FormControl>
      </Box>

      {/* Koniec czy dzialania zostaly podjete */}

      {/* Gdzie zapis dzialan korygujacych */}
      {actions === true && (
        <Box sx={{ mt: 2 }}>
          <Typography
            variant="h6"
            component="h2"
            gutterBottom
            fontWeight="bold"
            fontStyle="italic"
          >
            {t('rnModule.fiz_2.if_yes')}
          </Typography>
          <Divider sx={{ width: '100%', mb: 2, bgcolor: '#C09A53' }} />
          <FormControl sx={{ width: '100%' }}>
            <RadioGroup
              aria-labelledby="actions-taken-radio-buttons"
              name="actions-taken-name"
              value={saveIn}
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-evenly',
              }}
            >
              <FormControlLabel
                value={t('rnModule.fiz_2.form')}
                control={<Radio />}
                label={t('rnModule.fiz_2.form')}
                onChange={() => {
                  setSaveIn(t('rnModule.fiz_2.form'));
                }}
              />
              <FormControlLabel
                value={t('rnModule.fiz_2.problemDatabase')}
                control={<Radio />}
                label={t('rnModule.fiz_2.problemDatabase')}
                onChange={() => {
                  setSaveIn(t('rnModule.fiz_2.problemDatabase'));
                }}
              />
              {saveIn === t('rnModule.fiz_2.problemDatabase') && (
                <TextField
                  label={t('rnModule.fiz_2.problemDatabaseNumber')}
                  value={problemDatabaseNumber}
                  onChange={(e) => setProblemDatabaseNumber(e.target.value)}
                  variant="outlined"
                  sx={{ width: '15%', ml: 2, mr: 2 }}
                />
              )}
              <FormControlLabel
                value={t('rnModule.fiz_2.other')}
                control={<Radio />}
                label={t('rnModule.fiz_2.other')}
                onChange={() => {
                  setSaveIn(t('rnModule.fiz_2.other'));
                }}
              />
            </RadioGroup>
          </FormControl>
        </Box>
      )}
      {/* Koniec zapisu dzialan korygujacych */}
      <Box sx={{ mt: 2, mb: 2 }}>
        <Typography
          variant="h6"
          component="h2"
          gutterBottom
          fontWeight="bold"
          fontStyle="italic"
        >
          {t('rnModule.fiz_2.additionalDescription')}
        </Typography>
        <Divider sx={{ width: '100%', mb: 2, bgcolor: '#C09A53' }} />
        <TextField
          label={t('rnModule.fiz_2.qtyCasBlocked')}
          value={casQty}
          onChange={(e) => setCasQty(e.target.value)}
          variant="outlined"
          sx={{ width: '25%', mr: 2 }}
        />
        <TextField
          label={t('rnModule.fiz_2.qtyHLBlocked')}
          value={hlQty}
          disabled
          variant="outlined"
          sx={{ width: '25%', mr: 2 }}
        />
      </Box>

      <Button
        type="submit"
        variant="contained"
        color="primary"
        sx={{
          height: '40px',
          width: '150px',
          mt: 2,
          mb: 50,
          mr: 2,
        }}
      >
        {t('rnModule.fiz_2.button.saveChanges')}
      </Button>
      {/* <Button
        onClick={() => handleSave()}
        sx={{
          color: 'white',
          bgcolor: '#C09A53',
          ':hover': { bgcolor: '#9c7c43' },
          height: '40px',
          width: '300px',
          mt: 2,
          mb: 50,
        }}
      >
        {t('rnModule.fiz_2.button.confirmData')}
      </Button> */}
    </Box>
  );
};

export default RozlewFiz;
